module.exports = __webpack_public_path__ + "static/media/keynote.4125d349.svg";